import { render, staticRenderFns } from "./homeTpl.vue?vue&type=template&id=76ffb974&"
import script from "./homeTpl.vue?vue&type=script&lang=js&"
export * from "./homeTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports